module.exports = __webpack_public_path__ + "static/img/logo_repsol.981a24e.png";


//////////////////
// WEBPACK FOOTER
// ./demo/logo_repsol.png
// module id = 7sNt
// module chunks = 1